module.exports = {"id":"215559","name":"Lucas Evangelista","rating":"74","photo":"./data/images/photos/1/215559.png","club":{"name":"Estoril Praia","logo":"./data/images/clubs/EstorilPraia.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucasEvangelista0.json
// module id = 2570
// module chunks = 0